import { invariant } from '#src/invariant.ts'

/** A named entry in the shared chip color palette. */
export interface ChipColor {
  name: string
  color: string
}

/**
 * Single source of truth for chip colors. Both the note-label color picker
 * (`Label.defaultColors`) and the hard-coded visit-note category registry draw
 * from this palette so their chips stay visually consistent — neither hard-codes
 * its own hex values.
 */
export const CHIP_COLORS: ChipColor[] = [
  { name: 'Gray', color: '#bec2c8' },
  { name: 'Dark Gray', color: '#95a2b3' },
  { name: 'Purple', color: '#5e6ad2' },
  { name: 'Teal', color: '#26b5ce' },
  { name: 'Green', color: '#4cb782' },
  { name: 'Yellow', color: '#f2c94c' },
  { name: 'Orange', color: '#f2994a' },
  { name: 'Pink', color: '#f7c8c1' },
  { name: 'Red', color: '#eb5757' },
]

/** Resolve a palette color value by its display name. */
export function chipColor(name: string): string {
  const found = CHIP_COLORS.find((c) => c.name === name)
  invariant(found, `Unknown chip color: ${name}`)
  return found.color
}
